import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/pages/login";
import ProtectedRoute from "./components/ProtectedRoute";
// import config from "config";
//Settings imports removed - not accessible
// Assets removed - not accessible
//Doctor
import DoctorList from "./components/doctor/DoctorList";
import AddDoctor from "./components/doctor/AddDoctor";
import EditDoctor from "./components/doctor/EditDoctor";
import DoctorProfileMedical from "./components/doctor/DoctorProfileMedical";
//Patients...
import PatientsList from "./components/patients/PatientsList";
import PatientsListBulgarian from "./components/patients/PatientsListBulgarian";
import AddPatients from "./components/patients/AddPatients";
import AddPatientsBulgarian from "./components/patients/AddPatientsBulgarian";
import EditPatients from "./components/patients/EditPatients";
import PatientProfileMedical from "./components/patients/PatientProfileMedical";
// Medical Visits
import PatientVisitsHistory from "./components/visits/PatientVisitsHistory";
import AllVisitsHistory from "./components/visits/AllVisitsHistory";
import VisitForm from "./components/visits/VisitForm";
import VisitDetail from "./components/visits/VisitDetail";
import UploadXML from "./components/visits/UploadXML";
import AppoinmentList from "./components/appoinments/AppoinmentList";
import AddAppoinments from "./components/appoinments/AddAppoinments";
import EditAppoinments from "./components/appoinments/EditAppoinments";
// Doctor Schedule removed - not accessible
// Staff management removed - not accessible
import ForgotPassword from "./components/pages/login/ForgotPassword";
import ResetPassword from "./components/pages/login/ResetPassword";
import RegisterPatient from "./components/pages/login/RegisterPatient";
import ConfirmEmail from "./components/pages/login/ConfirmEmail";
import ResendConfirmation from "./components/pages/login/ResendConfirmation";
import ChangePassword from "./components/pages/settings/ChangePassword";
import NotFound from "./components/pages/NotFound";
// Legal pages
import TermsAndConditions from "./components/pages/legal/TermsAndConditions";
import PrivacyPolicy from "./components/pages/legal/PrivacyPolicy";
// UI Elements, Forms, Tables removed - not accessible
// Additional pages removed - not accessible
// Error pages and additional login pages removed - not accessible
// SafeDashboard removed - all original dashboards now working
import Doctor_Dashboard from "./components/Dashboard/Doctor_Dashboard/Doctor_Dashboard";
import Admin_Dashboard from "./components/Dashboard/Admin_Dashboard/Admin_Dashboard";
import Patient_Dashboard from "./components/Dashboard/Patient_Dashboard/Patient_Dashboard";
// Error test components removed  
import Doctor_Settings from "./components/Dashboard/Doctor_Dashboard/Doctor_Settings";
import Patient_Settings from "./components/patients/Patient_Settings";
import AIAssistant from "./components/ai/AIAssistant";
// Telemedicine Chat - Patient
import PatientChatList from "./components/telechat/PatientChatList";
import NewConsultation from "./components/telechat/NewConsultation";
import PatientChatDetail from "./components/telechat/PatientChatDetail";
// Telemedicine Chat - Doctor
import DoctorChatList from "./components/telechat/DoctorChatList";
import DoctorChatDetail from "./components/telechat/DoctorChatDetail";
// Gallery removed - not accessible

//Accounts
const Approuter = () => {
  // eslint-disable-next-line no-unused-vars
  // const config = "/react/template"
  return (
    <>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterPatient />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/resend-confirmation" element={<ResendConfirmation />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          {/* Additional pages routes removed - not accessible */}
          {/* Settings routes removed - not accessible without menu */}
          {/* Assets routes removed - not accessible */}
          {/* Doctor - ADMIN/STAFF only */}
          <Route path="/doctors" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><DoctorList /></ProtectedRoute>} />
          <Route path="/doctors/add" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AddDoctor /></ProtectedRoute>} />
          <Route path="/doctors/edit/:id" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><EditDoctor /></ProtectedRoute>} />
          <Route path="/doctors/medical-profile/:id" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><DoctorProfileMedical /></ProtectedRoute>} />
          <Route path="/doctors/settings" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'DOCTOR']}><Doctor_Settings /></ProtectedRoute>} />
          {/* Patients - ADMIN/DOCTOR (view), ADMIN only (add/edit) */}
          <Route path="/patients" element={<ProtectedRoute allowedRoles={['ADMIN', 'DOCTOR']}><PatientsListBulgarian /></ProtectedRoute>} />
          <Route path="/patients/add" element={<ProtectedRoute allowedRoles={['ADMIN']}><AddPatientsBulgarian /></ProtectedRoute>} />
          <Route path="/patients/edit/:id" element={<ProtectedRoute allowedRoles={['ADMIN']}><EditPatients /></ProtectedRoute>} />
          <Route path="/patients/medical-profile/:id" element={<ProtectedRoute allowedRoles={['ADMIN', 'DOCTOR']}><PatientProfileMedical /></ProtectedRoute>} />
          <Route path="/patients/settings" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'PATIENT']}><Patient_Settings /></ProtectedRoute>} />
          {/* Medical Visits - ADMIN/STAFF only */}
          <Route path="/visits" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AllVisitsHistory /></ProtectedRoute>} />
          <Route path="/visits/new" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><VisitForm /></ProtectedRoute>} />
          <Route path="/visits/:visitId" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><VisitDetail /></ProtectedRoute>} />
          <Route path="/visits/:visitId/edit" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><VisitForm /></ProtectedRoute>} />
          <Route path="/visits/upload" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><UploadXML /></ProtectedRoute>} />
          <Route path="/upload-xml" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><UploadXML /></ProtectedRoute>} />
          <Route path="/ai-assistant" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AIAssistant /></ProtectedRoute>} />
          {/* Telemedicine Chat - Patient views (PATIENT + ADMIN/STAFF) */}
          <Route path="/telechat" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'PATIENT']}><PatientChatList /></ProtectedRoute>} />
          <Route path="/telechat/new" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'PATIENT']}><NewConsultation /></ProtectedRoute>} />
          <Route path="/telechat/:chatId" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'PATIENT']}><PatientChatDetail /></ProtectedRoute>} />
          {/* Telemedicine Chat - Doctor views (DOCTOR + ADMIN/STAFF) */}
          <Route path="/doctor/telechat" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'DOCTOR']}><DoctorChatList /></ProtectedRoute>} />
          <Route path="/doctor/telechat/:chatId" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'DOCTOR']}><DoctorChatDetail /></ProtectedRoute>} />
          {/* Patient visits - ADMIN/STAFF only */}
          <Route path="/patients/:patientId/visits" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><PatientVisitsHistory /></ProtectedRoute>} />
          <Route path="/patients/:patientId/visits/new" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><VisitForm /></ProtectedRoute>} />
          <Route path="/patients/:patientId/visits/:visitId" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><VisitDetail /></ProtectedRoute>} />
          <Route path="/patients/:patientId/visits/:visitId/edit" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><VisitForm /></ProtectedRoute>} />
          {/* Appoinments - ADMIN/STAFF only */}
          <Route path="/visits/edit" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><EditAppoinments /></ProtectedRoute>} />
          {/* Doctor Schedule routes removed - not accessible */}
          {/* Staff routes removed - not accessible */}
          {/* UI Elements, Forms, Tables routes removed - not accessible */}
          {/* Dashboard - role-based access */}
          <Route path="/admin-dashboard" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><Admin_Dashboard /></ProtectedRoute>} />
          <Route path="/doctor-dashboard" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF', 'DOCTOR']}><Doctor_Dashboard /></ProtectedRoute>} />
          <Route path="/patient-dashboard" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><Patient_Dashboard /></ProtectedRoute>} />
          
          {/* Modern React Query Demo removed - not in menu */}
          
          {/* 404 Not Found - catch all unknown routes */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      <div className="sidebar-overlay" onClick={() => {
        document.body.classList.remove("slide-nav");
        document.getElementsByTagName("html")[0].classList.remove('menu-opened');
        document.querySelector('.sidebar-overlay')?.classList.remove("opened");
      }}></div>
    </>
  );
};

export default Approuter;
